var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results-count"},[_c('small',[_vm._v("Found "),_c('strong',[_vm._v(_vm._s(_vm.itemCount))]),_vm._v(" events")])])
}
var staticRenderFns = []

export { render, staticRenderFns }